import { FC } from 'react';
import { CancellationRequestViewProvider } from '../../hooks/use-cancellation-request-view';
import { CancellationRequestView } from './cancellation-request';

export interface CancellationRequestViewWithProviderProps {
  apptRequestId: number;
}

export const CancellationRequestViewWithProvider: FC<CancellationRequestViewWithProviderProps> = (props) => (
  <CancellationRequestViewProvider apptRequestId={props.apptRequestId}>
    <CancellationRequestView />
  </CancellationRequestViewProvider>
);
